{
  "title": "Ops setup",
  "needCt": "Only a session proven with the room admin code can open this screen.",
  "needCtLink": "Enter the admin code",
  "ctSessionEnded": "This CT session has ended. Enter the admin code again. If it doesn't match, the code has changed, so get the new code.",
  "ctSessionRotated": "The admin code was reissued, so this CT session ended. Get the new admin code from the CT who reissued it and enter it.",
  "ctSessionOtherTab": "Another tab in this browser now holds the CT session, so this tab ended. Continue in that tab. If you closed it, reload this tab.",
  "ctSessionReloadTab": "Reload this tab",
  "onboardingTitle": "First step to opening this room",
  "onboardingWhy": "The name you put here shows up at the second step of joining. Until it is filled in, even a correct join code is rejected.",
  "onboardingNickname": "CT nickname",
  "onboardingSave": "Save and open",
  "drawerOpen": "Connected",
  "drawerClose": "Close",
  "presenceTitle": "Connected",
  "presenceEmpty": "No one has come in yet",
  "connections": "connections",
  "kick": "Kick",
  "codesTitle": "Two codes",
  "codesReveal": "Reveal",
  "codesHide": "Hide",
  "codesJoin": "Shared join code",
  "codesAdmin": "Room admin code",
  "codesRotateJoin": "Reissue join code",
  "codesRotateAdmin": "Reissue admin code",
  "codesRoomCount": "Rooms on this server",
  "codesIssuedAt": "Last issued",
  "codesWarning": "Reissuing the admin code does not touch the shared join code.",
  "whitelistTitle": "whitelist",
  "whitelistWhy": "A game ID that is not on the list cannot get in, even knowing the code.",
  "whitelistWhere": "Adding people, fixing names, and taking them off the list all happen in the roster list on the roster tab.",
  "whitelistEmpty": "No one is registered yet",
  "nextStepLabel": "Next",
  "nextSeedRoster": "Add allies on the roster tab",
  "nextAddMain": "Create the main. It is the origin of the impact axis",
  "nextAddSub": "Add a sub, or finish assembling",
  "nextSetHandle": "Decide how far from now the earliest open sits",
  "nextDispatch": "Confirm. The moment you press it, the times are fixed",
  "rallyTitle": "rally editor",
  "rallyWhy": "Build one line at a time on the left; they stack on the right. Up to here there is no absolute time. You only set the gaps between lines.",
  "formTitle": "Build one rally line",
  "typeLabel": "Type",
  "typeMainTaken": "There is only one main. It already exists",
  "needMainFirst": "Create the main first. It is the reference for impact offsets",
  "rosterLabel": "roster in charge",
  "rosterPick": "Choose one",
  "rosterNeed": "Choose who takes this line.",
  "rosterEmpty": "No allies in the roster list",
  "rosterNeedsMarching": "needs marching",
  "rosterNeedsMarchingWhy": "{name} has no marching time yet. Put it in first from the roster list on the roster tab.",
  "rosterGone": "off the roster list",
  "rallyingLabel": "Rallying time",
  "rallyingLabelHint": "Compare all four options",
  "rallyingWhy": "The longer the rallying time, the earlier that line opens. The impact stays where it is.",
  "rallyingMinutes": "{n} min",
  "rallyingLeadFirst": "opens first",
  "rallyingLeadAfter": "earliest open + {value}",
  "rallyingShift": "existing lines shift by {value}",
  "rallyingShiftNone": "existing lines stay put",
  "rallyingBlocked": "Blocked",
  "offsetLabel": "impact offset = main impact + Δ",
  "offsetMainZero": "The main's impact offset is 0. The main is the origin of the impact axis.",
  "confirmRally": "Add this line",
  "miniTitle": "Sequence",
  "miniWhy": "Every line you add stacks here at once. The line you just added is marked with a dashed edge, and the mark follows that line when you change the sort.",
  "miniEmpty": "No lines yet. Create the main on the left first.",
  "miniFresh": "just added",
  "miniRemove": "remove",
  "miniMainLocked": "The main cannot be removed while subs remain. Remove the subs first.",
  "columnRoster": "roster",
  "columnRallying": "rallying",
  "columnOpenDelta": "open Δ",
  "columnImpactDelta": "impact Δ",
  "openDeltaWhy": "vs earliest open",
  "impactDeltaWhy": "vs main impact",
  "sequenceConfirm": "Finish assembling",
  "sequenceConfirmWhy": "Once you finish, the time handle appears below. Before that, neither the time handle nor the Confirm button is on screen.",
  "sequenceConfirmed": "Assembling is done. Now set the time.",
  "notFixedYet": "The times are not fixed yet. They are fixed the moment you confirm.",
  "handleTitle": "Time handle",
  "handleTitleHint": "How far from now the earliest open sits",
  "handlePreset": "{value}s",
  "handleCustom": "Custom",
  "handleApply": "Apply",
  "handleApplied": "The earliest open sits {value} from now.",
  "handleFloorWhy": "The signal runs for the 5 seconds before open, so it cannot sit sooner than 6 seconds.",
  "dispatch": "Confirm",
  "dispatchWhy": "The moment you press it, absolute times are fixed and go out to everyone connected.",
  "dispatchBadge": "Confirmed, times fixed",
  "dispatchBadgeWhy": "The times of this ops are fixed. Editing marching in the roster list does not move this sequence.",
  "reopen": "Edit ops",
  "reopenGo": "Return to editing",
  "reopenConfirm": "Press the button below to return to editing. All {n} rally lines stay. If marching was edited in the roster list meanwhile, only the open times are recalculated with those values.",
  "reopenOpenedNone": "No rally has opened yet.",
  "reopenOpenedSome": "Rally lines already opened: {n}. Their countdowns disappear, and troops already out do not come back.",
  "reopenCancel": "Cancel",
  "reopened": "Back in editing. The lineup is unchanged. Fix the lines, set the time again, and confirm.",
  "reopenWhy": "Editing keeps the lineup; discarding throws it away. Going back clears the countdown on every alliance member's screen, and even after you confirm again, each of them has to pick what to listen to.",
  "discard": "Discard ops",
  "discardGo": "Discard permanently",
  "discardConfirm": "Pressing the button below deletes this ops. Every rally line goes with it, {n} in all, and it cannot be undone. To keep the lineup and edit it, cancel and press “Edit ops”. The roster list stays.",
  "discardCancel": "Cancel",
  "discarded": "The ops is discarded. Build a new one.",
  "cardCount": "rally lines: {n}",
  "retimeTitle": "Retime",
  "retimeTitleHint": "Same lineup, time only",
  "retimeQuick": "Retime to 30s from now",
  "retimeQuickWhy": "Only open times change. Assignments and rally settings stay unchanged.",
  "retimeCustom": "Custom",
  "retimeApply": "Apply",
  "retimeApplied": "Set to: {value}.",
  "retimeMarching": "Marching edited in the roster list is picked up when you retime.",
  "retimed": "Retimed. The lineup is unchanged.",
  "editRally": "Edit",
  "editRallyClose": "Cancel",
  "editTitle": "Editing {name}'s line",
  "editWhy": "Edit the impact offset, rallying time, and roster in charge here. Marching is edited only in the roster list.",
  "editRosterLabel": "Change roster in charge",
  "editApply": "Save",
  "editUnsaved": "You have unsaved changes.",
  "editUnsavedSwitch": "Discard them to open {name}'s line.",
  "editUnsavedClose": "Discard them to close the editor.",
  "editKeepEditing": "Keep editing",
  "editDiscard": "Discard changes",
  "editChangedElsewhere": "This line was changed elsewhere. Fields you did not touch now show the new values.",
  "editDroppedRemote": "This ops was edited or discarded elsewhere, so the line editor closed. Unsaved input was not kept.",
  "leaveDropsEdit": "Unsaved input in the open line editor will be lost too.",
  "edited": "Edited. The main impact is unchanged.",
  "counterTitle": "Add a counter rally",
  "counterWhy": "Once you occupy a building you cannot open a rally on it. Open one before you occupy it and hold it with a long rallying time.",
  "counterMainFixed": "The main impact is already fixed. A new line attaches to that reference.",
  "rallyingLead": "open lead {value}",
  "rallyingMinimumOffset": "offset {value} or later",
  "rallyingNoShift": "Existing lines do not shift",
  "nextRetime": "Retime and it goes out again with the same lineup",
  "retimeWillApply": "Press it and the earliest open lands {value} from now.",
  "counterAdded": "Added: {name}, impact main {offset}. Existing lines unchanged.",
  "rallyWhyCounter": "You are adding one line to the ops under way. The moment you add it, that line's impact time is set."
}
